/* eslint-disable no-script-url */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { getCurrentOrganization, getOrganizationPropertiesByHost } from '../../../utils/helpers';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

export default function Main({ list }) {
  const [openMobileIndex, setOpenMobileIndex] = useState(null);
  const { miscellaneousData } = useMiscellaneousData();
  let organizationProperties;
  if (miscellaneousData?.hostname) {
    organizationProperties = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  } else {
    organizationProperties = getCurrentOrganization();
  }
  const isNextIas = organizationProperties?.organizationName === 'nextias';

  console.log('isNextIas:', isNextIas);

  return (
    <ul className="items-center xl:flex">
      {
        list.map((item, index) => (
          <li
            key={index}
            className="border-b border-gray-200 py-1 w-full xl:w-auto xl:py-0 xl:border-0"
          >
            <div
              className={`relative inline-block text-left group w-full xl:w-auto ${isNextIas ? '' : 'xl:mr-3'}`}
            >
              <Link
                href={item.url || '#'}
                className={`${item.class} block w-full`}
                onClick={(e) => {
                  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
                  const hasDropdown = item.sub_menu && item.sub_menu.length > 0;

                  if (isMobile && hasDropdown) {
                    // toggle dropdown only for mobile
                    e.preventDefault();
                    setOpenMobileIndex(openMobileIndex === index ? null : index);
                    return;
                  }

                  // allow normal navigation for desktop
                  if (!item.url || item.url === '#') {
                    e.preventDefault();
                  } else {
                    e.preventDefault();
                    window.location.href = item.url; // reload
                  }
                }}
              >
                {item.menu_name}
              </Link>

              {item.sub_menu?.length > 0 && (
              <div
                className={`xl:absolute xl:left-0 xl:hidden xl:group-hover:block xl:z-50 ${openMobileIndex === index ? 'static block w-full' : 'hidden'} ${isNextIas ? 'rounded-[6px] bg-white border border-gray-300' : `${item.menu_type === 'mega_menu' ? 'xl:h-[400px]' : ''} shadow-lg`} xl:w-auto min-w-full max-w-full w-full`}
              >
                <ul className={`${isNextIas ? 'py-2' : `${item.menu_type === 'mega_menu' ? 'border-y-8 border-[#e4f2ff]' : 'border-y-8 border-gray-100'}`} text-gray-700 ${!isNextIas && item.menu_type === 'mega_menu' ? 'h-full bg-[#e4f2ff]' : 'bg-white'} w-fit md:relative`}>
                  {item.sub_menu.map((subItem, subIndex) => (
                    <li
                      key={subIndex}
                      className={`group/sub cursor-pointer font-normal ${item.menu_name?.toLowerCase() === 'free resources' ? 'xl:relative' : ''} ${isNextIas ? '' : `${item.menu_type === 'mega_menu' ? 'border-[#e4f2ff] border-r-0' : 'border-gray-100 border-l-8 border-r-8'} border-t-0 border-l-8 border-b-0`}`}
                    >
                      <Link
                        href={subItem.url === '#' ? 'javascript:void(0)' : subItem.url || '#'}
                        onClick={(e) => {
                          if (!subItem.url || subItem.url === '#') e.preventDefault();
                        }}
                        className={`${subItem.class} flex items-center whitespace-normal break-words ${isNextIas ? '' : ''}`}
                      >
                        {subItem.menu_name === 'Prelims Revision & Practice Course' ? (
                          <div>
                            <span className="relative inline-block pr-2">
                              Prelims Revision &
                              <br />
                              Practice Course
                              <img
                                src="https://cdnstatic.nextias.com/resources/images/icons/896364502151419600_image.gif"
                                width={33}
                                height={16}
                                alt="new"
                                className="absolute new-img"
                                style={{
                                  top: '12px',
                                  right: '-60px',
                                  filter: 'drop-shadow(0px 4px 7px rgba(0, 0, 0, .4))',
                                }}
                              />
                            </span>
                          </div>

                        ) : (
                          <span>{subItem.menu_name}</span>
                        )}

                        {
                            subItem.sub_menu && subItem.sub_menu.length > 0 && (
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000">
                              <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                              <g id="SVGRepo_iconCarrier"><path d="M10 7L15 12L10 17" stroke={`${isNextIas ? '#ED3237' : '#0267b1'}`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></g>
                            </svg>
                            )
                        }
                      </Link>

                      {/* Second Dropdown (Level 3) */}
                      {subItem.sub_menu?.length > 0 && (
                      <div className={`static left-0 block w-full max-w-full min-w-0 xl:absolute xl:left-full xl:hidden 
                      ${isNextIas ? 'xl:border xl:border-gray-300 xl:rounded-md' : 'xl:shadow-[10px_10px_15px_rgba(0,0,0,0.1)]'}
                      xl:group-hover/sub:block xl:top-0 overflow-y-auto bg-white xl:z-50 xl:w-max xl:max-w-none 
                      ${isNextIas ? 'xl:py-2' : `${item.menu_type !== 'mega_menu' ? 'xl:translate-x-2' : 'xl:h-[400px]'}`} ${subItem.menu_name === 'Postal Courses' ? 'xl:h-[220px]' : ''}`}
                      >
                        {!isNextIas && item.menu_type === 'mega_menu' && (
                        <span className="border-t-8 border-l-8 border-r-8 border-gray-100 px-4 py-2 border-b text-lg font-bold whitespace-normal break-words">{subItem.menu_name}</span>
                        )}
                        <ul className={`${isNextIas ? '' : `${item.menu_type === 'mega_menu' ? 'border-b-8 h-full border-x-8 overflow-y-auto' : 'border-y-8'} border-gray-100`} text-gray-700 pl-4 overflow-x-visible xl:pl-0 xl:overflow-x-hidden`}>
                          {subItem.sub_menu.map((subSubItem, subSubIndex) => (
                            <li key={subSubIndex} className={`${isNextIas ? '' : `${item.menu_type === 'mega_menu' ? '' : 'border-x-8 border-gray-100'}`}`}>
                              {subSubItem.sub_menu?.length > 0 ? (
                                <span href={subSubItem.url === '#' ? 'javascript:void(0)' : subSubItem.url || '#'}>
                                  <span className={`${subSubItem.class} whitespace-normal break-words xl:whitespace-nowrap pl-2`}>
                                    {subSubItem.menu_name}
                                  </span>
                                  <ul className={`${!isNextIas && item.menu_type === 'mega_menu' ? 'flex items-center flex-wrap gap-3 ml-4 mb-6' : ''} pl-4 xl:pl-0`}>
                                    {subSubItem.sub_menu?.map(
                                      (deepItem, deepIndex) => {
                                        const hasValidUrl = deepItem?.url && deepItem?.url !== '#';
                                        const linkHref = hasValidUrl ? deepItem.url : 'javascript:void(0)';
                                        return (
                                          <li key={deepIndex}>
                                            {hasValidUrl ? (
                                              <Link
                                                href={linkHref}
                                                onClick={(e) => {
                                                  if (linkHref && linkHref !== '#') {
                                                    window.location.href = linkHref; // RELOAD
                                                  }
                                                  if (!hasValidUrl) e.preventDefault();
                                                }}
                                                className={`${deepItem?.class} whitespace-normal break-words xl:whitespace-nowrap hover:bg-blue-100`}
                                              >
                                                {deepItem?.menu_name}
                                              </Link>
                                            ) : (
                                              <span className={`${deepItem?.class} whitespace-normal break-words xl:whitespace-nowrap`}>
                                                {deepItem?.menu_name}
                                              </span>
                                            )}
                                          </li>
                                        );
                                      },
                                    )}
                                  </ul>
                                </span>
                              ) : (
                              // Normal single link
                                <Link
                                  href={subSubItem.url === '#' ? 'javascript:void(0)' : subSubItem.url || '#'}
                                  onClick={(e) => {
                                    if (
                                      !subSubItem.url
                                    || subSubItem.url === '#'
                                    ) { e.preventDefault(); }
                                    if (subSubItem.url && subSubItem.url !== '#') {
                                      window.location.href = subSubItem.url; // RELOAD
                                    }
                                  }}
                                  className={`${subSubItem.class} whitespace-normal break-words xl:whitespace-nowrap`}
                                >
                                  {subSubItem.menu_name}
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              )}
            </div>
          </li>
        ))
    }
    </ul>
  );
}
Main.propTypes = {
  list: PropTypes.array,
};
